import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import ChangePasswordModal from './ChangePasswordModal'
import './Layout.css'

const COORD_NAV = [
  { section: 'Vue générale', items: [
    { id: 'dashboard', label: 'Dashboard', icon: '⊞' },
  ]},
  { section: 'Gestion', items: [
    { id: 'saisie', label: 'Saisie des séances', icon: '✎' },
    { id: 'recap', label: 'Récapitulatif mensuel', icon: '≡' },
    { id: 'recap-annuel', label: 'Récapitulatif annuel', icon: '◫' },
    { id: 'to', label: 'Taux d\'occupation', icon: '◑' },
    { id: 'financier', label: 'Suivi financier', icon: '⊟' },
    { id: 'reunions', label: 'Réunions', icon: '☷' },
    { id: 'rapports', label: 'Rapports', icon: '⎙' },
  ]},
  { section: 'Planning', items: [
    { id: 'planning-annuel', label: 'Construire le planning', icon: '▤' },
    { id: 'assistanat', label: 'Assistanat de cours', icon: '▥' },
    { id: 'campagne', label: 'Campagne de dispos', icon: '◷' },
    { id: 'calendrier', label: 'Calendrier d\'ouverture', icon: '▦' },
    { id: 'nouvelle-saison', label: 'Nouvelle saison', icon: '＋' },
  ]},
  { section: 'Administration', items: [
    { id: 'tarifs', label: 'Soins & Tarifs', icon: '◈' },
    { id: 'superviseurs', label: 'Superviseurs', icon: '◎' },
  ]},
]

const SUPER_NAV = [
  { section: 'Mon espace', items: [
    { id: 'mon-planning', label: 'Mon planning', icon: '▣' },
    { id: 'moneespace', label: 'Mes séances', icon: '≡' },
    { id: 'assistanat-sup', label: 'Assistanat de cours', icon: '▥' },
    { id: 'mes-dispos', label: 'Mes disponibilités', icon: '✓' },
    { id: 'recap-annuel-sup', label: 'Récapitulatif annuel', icon: '◫' },
  ]},
]

function initiales(prenom, nom) {
  return ((prenom?.[0] || '') + (nom?.[0] || '')).toUpperCase()
}

function dateLabel() {
  return new Date().toLocaleDateString('fr-FR', { weekday:'long', day:'numeric', month:'long', year:'numeric' })
}

const PAGE_LABELS = {
  dashboard: 'Dashboard',
  saisie: 'Saisie des séances',
  recap: 'Récapitulatif mensuel',
  'recap-annuel': 'Récapitulatif annuel',
  to: 'Taux d\'occupation',
  financier: 'Suivi financier',
  reunions: 'Réunions',
  rapports: 'Rapports',
  superviseurs: 'Superviseurs',
  tarifs: 'Soins & Tarifs',
  'planning-annuel': 'Construire le planning',
  assistanat: 'Assistanat de cours',
  campagne: 'Campagne de disponibilités',
  calendrier: 'Calendrier d\'ouverture',
  'nouvelle-saison': 'Nouvelle saison',
  'mon-planning': 'Mon planning',
  'assistanat-sup': 'Assistanat de cours',
  'mes-dispos': 'Mes disponibilités',
  moneespace: 'Mes séances',
  'recap-annuel-sup': 'Récapitulatif annuel',
}

export default function Layout({ children, activePage, onNavigate }) {
  const { profile, signOut } = useAuth()
  const [showModal, setShowModal] = useState(false)
  const nav = profile?.role === 'coordination' ? COORD_NAV : SUPER_NAV

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="sidebar-brand-name">Spa des Élèves</div>
          <div className="sidebar-brand-sub">EIS · Gestion</div>
        </div>

        <button className="sidebar-user" onClick={() => setShowModal(true)} title="Changer mon mot de passe">
          <div className="sidebar-avatar">{initiales(profile?.prenom, profile?.nom)}</div>
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">{profile?.prenom} {profile?.nom}</div>
            <div className="sidebar-user-role">{profile?.role}</div>
          </div>
          <div className="sidebar-user-edit">✎</div>
        </button>

        <nav className="sidebar-nav">
          {nav.map(section => (
            <div key={section.section}>
              <div className="sidebar-section-label">{section.section}</div>
              {section.items.map(item => (
                <button
                  key={item.id}
                  className={`sidebar-item ${activePage === item.id ? 'active' : ''}`}
                  onClick={() => onNavigate(item.id)}
                >
                  <span className="sidebar-item-icon">{item.icon}</span>
                  {item.label}
                </button>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="btn-logout-sidebar" onClick={signOut}>
            <span>→</span> Déconnexion
          </button>
        </div>
      </aside>

      <div className="layout-main">
        <div className="layout-topbar">
          <span className="topbar-title">{PAGE_LABELS[activePage] || ''}</span>
          <span className="topbar-date">{dateLabel()}</span>
        </div>
        <div className="layout-content">
          {children}
        </div>
      </div>

      {showModal && <ChangePasswordModal onClose={() => setShowModal(false)} />}
    </div>
  )
}
